import { MockFactory } from '@tino-frontend/mocks'
import type { PaymentLink } from '@types'
import { PaymentLinkStatus } from '@types'

export const paymentLinkReservationExpiredMock = new MockFactory<PaymentLink>({
  id: 'payment-link-id-reservation-expired',
  created_at: '2023-07-07T19:24:23.721429Z',
  limit_reservation: {
    created_at: '2023-07-07T19:24:23.721429Z',
    expiration_date: '2023-07-17T19:24:23.721429Z',
  },
  external_id: 'external_id_1',
  status: PaymentLinkStatus.ReservationExpired,
  merchant_name: '',
  amount_cents: 2000,
})
